import type { ReactNode } from "react"

export function StatCard({
  label,
  value,
  helper,
  trend,
  borderColor,
  tone = "slate",
}: {
  label: string
  value: ReactNode
  helper?: string
  trend?: { direction: "up" | "down"; text: string; positive?: boolean }
  borderColor?: string
  tone?: "slate" | "blue" | "emerald" | "amber" | "red"
}) {
  const toneClasses: Record<string, string> = {
    slate: "border-slate-200 bg-white",
    blue: "border-blue-200 bg-blue-50/60",
    emerald: "border-emerald-200 bg-emerald-50/60",
    amber: "border-amber-200 bg-amber-50/60",
    red: "border-red-200 bg-red-50/60",
  }

  return (
    <div
      className={`rounded-2xl border p-4 shadow-sm ${
        toneClasses[tone]
      } ${borderColor ? `border-b-2 ${borderColor}` : ""}`}
    >
      <p className="text-[10px] text-slate-500 font-bold uppercase tracking-tight">{label}</p>
      <p className="text-lg font-bold text-slate-800 mt-1">{value}</p>
      {trend ? (
        <p
          className={`text-[0.65rem] font-medium mt-1 flex items-center ${
            trend.positive !== false
              ? trend.direction === "up"
                ? "text-emerald-600"
                : "text-red-600"
              : trend.direction === "up"
                ? "text-red-600"
                : "text-emerald-600"
          }`}
        >
          {trend.direction === "up" ? (
            <svg className="h-2 w-2 mr-1" fill="currentColor" viewBox="0 0 20 20">
              <path d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" />
            </svg>
          ) : (
            <svg className="h-2 w-2 mr-1" fill="currentColor" viewBox="0 0 20 20">
              <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
            </svg>
          )}
          {trend.text}
        </p>
      ) : null}
      {helper && !trend ? (
        <p className="text-[0.65rem] text-slate-400 font-medium mt-1">{helper}</p>
      ) : null}
    </div>
  )
}
